import { inject, Injectable, Signal, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private language = signal<string | null>(null);
  private translate = inject(TranslateService);

  setLanguage(v: string) {
    this.translate.use(v);
    this.language.set(v);
  }

  getLanguage(): Signal<string | null> {
    return this.language.asReadonly();
  }
}
